var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visibility,
        "before-close": _vm.cancelNewForm,
        "custom-class": "cnf-dialog",
        width: "80%",
        top: "5vh"
      },
      on: {
        "update:visible": function($event) {
          _vm.visibility = $event
        }
      }
    },
    [
      _c(
        "template",
        { slot: "title" },
        [
          _c("div", { staticClass: "cnf-header" }, [
            _c("div", { staticClass: "cnf-header-left" }, [
              _c("h4", { staticClass: "cnf-title" }, [
                _vm._v("Create a New Form")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "cnf-subtitle" }, [
                _vm._v("Choose a template or start from scratch")
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cnf-header-right" },
              [
                _c("el-input", {
                  staticClass: "cnf-search",
                  attrs: {
                    placeholder: "Search templates…",
                    "prefix-icon": "el-icon-search",
                    clearable: "",
                    size: "small"
                  },
                  model: {
                    value: _vm.searchQuery,
                    callback: function($$v) {
                      _vm.searchQuery = $$v
                    },
                    expression: "searchQuery"
                  }
                }),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "cnf-import-btn",
                    attrs: {
                      size: "small",
                      type: _vm.showFormsImport ? "info" : "default"
                    },
                    on: {
                      click: function($event) {
                        _vm.showFormsImport = !_vm.showFormsImport
                      }
                    }
                  },
                  [
                    _c("i", {
                      class: _vm.showFormsImport
                        ? "el-icon-circle-close"
                        : "el-icon-upload2"
                    }),
                    _vm._v("\n          Import Form\n        ")
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "cnf-slide" } },
            [
              _vm.showFormsImport
                ? _c("import-forms", {
                    staticClass: "cnf-import-section",
                    attrs: { app: { forms: [] } },
                    on: { "forms-imported": _vm.updateFormsImported }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "cnf-body" }, [
        _c(
          "div",
          { staticClass: "cnf-grid" },
          [
            _c(
              "a",
              {
                staticClass: "cnf-card cnf-card--blank",
                attrs: { href: _vm.blankFormUrl }
              },
              [
                _c("div", { staticClass: "cnf-card-blank-inner" }, [
                  _c("span", { staticClass: "cnf-card-blank-icon" }, [
                    _c("i", { staticClass: "el-icon-plus" })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "cnf-card-blank-label" }, [
                    _vm._v("Blank Form")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.filteredTemplates, function(template, key) {
              return [
                _c(
                  "a",
                  {
                    key: key,
                    staticClass: "cnf-card",
                    class: { "cnf-card--disabled": !template.enabled },
                    attrs: { href: _vm.buildTemplateUrl(key) }
                  },
                  [
                    _c("div", { staticClass: "cnf-card-img-wrap" }, [
                      _c("img", {
                        staticClass: "cnf-card-img",
                        attrs: { src: template.image, alt: template.title }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "cnf-card-overlay" }, [
                        _c("span", { staticClass: "cnf-card-use-btn" }, [
                          _c("i", { staticClass: "el-icon-check" }),
                          _vm._v(" Use Template\n              ")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cnf-card-footer" }, [
                      _c("span", { staticClass: "cnf-card-title" }, [
                        _vm._v(_vm._s(template.title))
                      ]),
                      _vm._v(" "),
                      !template.enabled
                        ? _c("span", { staticClass: "cnf-card-pro-badge" }, [
                            _vm._v("Pro")
                          ])
                        : _vm._e()
                    ])
                  ]
                )
              ]
            })
          ],
          2
        ),
        _vm._v(" "),
        _vm.filteredTemplates && Object.keys(_vm.filteredTemplates).length === 0
          ? _c("div", { staticClass: "cnf-empty" }, [
              _c("i", { staticClass: "el-icon-search cnf-empty-icon" }),
              _vm._v(" "),
              _c("p", [
                _vm._v('No templates match "'),
                _c("strong", [_vm._v(_vm._s(_vm.searchQuery))]),
                _vm._v('"')
              ])
            ])
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }